import { types, Instance } from 'mobx-state-tree';
const { model, string } = types;

export const SmtpSettingsModel = model('SmtpSettingsModel', {
  name: string,
  key: string,
  value: string,
});

export type ISmtpSettingsModel = Instance<typeof SmtpSettingsModel>;
